import React from "react";
import { Route, Routes } from "react-router-dom";
import PreLoginLayout from "../../partials/Layouts/PreLoginLayout";
import Login from "./Auth/Login";
import Register from "./Auth/Register";
import ResetPassword from "./Auth/ResetPassword";
import ActivateUser from "./Auth/ActivateUser";
import ForgotPassword from "./Auth/ForgotPassword";
import Attendance from "./EmployeeAttendance/Attendance";
import AutoAttendance from "./EmployeeAttendance/AutoAttendance";


const PublicPortal = () => {
  return (
    <React.Suspense fallback={<div>Loading...</div>}>
      <Routes>
        <Route path="/" element={<>{<PreLoginLayout />}</>}>
          <Route
            path=""
            element={
              <React.Suspense fallback={<></>}>
                <Login />
              </React.Suspense>
            }
          />
          <Route
            path="/login"
            element={
              <React.Suspense fallback={<></>}>
                <Login />
              </React.Suspense>
            }
          />
          <Route
            path="/register"
            element={
              <React.Suspense fallback={<></>}>
                <Register />
              </React.Suspense>
            }
          />
          <Route
            path="/activation/:token"
            element={
              <React.Suspense fallback={<></>}>
                <ActivateUser />
              </React.Suspense>
            }
          />
          <Route
            path="/forget-password"
            element={
              <React.Suspense fallback={<></>}>
                <ForgotPassword />
              </React.Suspense>
            }
          />
          <Route
            path="/reset-password/:token"
            element={
              <React.Suspense fallback={<></>}>
                <ResetPassword />
              </React.Suspense>
            }
          />
          <Route
            path="/add-attendance"
            element={
              <React.Suspense fallback={<></>}>
                <Attendance />
              </React.Suspense>
            }
          />
          <Route
            path="/auto-attendance"
            element={
              <React.Suspense fallback={<></>}>
                <AutoAttendance />
              </React.Suspense>
            }
          />
        </Route>
      </Routes>
    </React.Suspense>
  );
};

export default PublicPortal;
